"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deserializeNumber = void 0;
const isFinite_1 = __importDefault(require("lodash/isFinite"));
const isSafeInteger_1 = __importDefault(require("lodash/isSafeInteger"));
const unwrap_1 = __importDefault(require("../util/unwrap"));
function deserializeNumber(value, minimum, maximum, isInteger) {
    let deserializedValue = value;
    if (!(0, isFinite_1.default)(deserializedValue)) {
        // try creating a number from the value, e.g., in the case of number strings ("10.00")
        deserializedValue = Number(deserializedValue);
        if (!isFinite_1.default) {
            throw new Error(`Value "${deserializedValue}" is not a number`);
        }
    }
    (0, unwrap_1.default)(minimum, minimum => {
        if (deserializedValue < minimum)
            throw new Error(`Number "${deserializedValue}" is less than minimum allowed`);
    });
    (0, unwrap_1.default)(maximum, maximum => {
        if (deserializedValue > maximum)
            throw new Error(`Number "${deserializedValue}" is greater than maximum allowed`);
    });
    if (isInteger && !(0, isSafeInteger_1.default)(value)) {
        throw new Error(`Value ${deserializedValue} is not an integer`);
    }
    return deserializedValue;
}
exports.deserializeNumber = deserializeNumber;
